/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Optional community-wide unlock goal on a Challenge. Stored shape — used
 * as the request schema on Challenge CREATE/UPDATE bodies. The shared
 * unlock code is NOT stored here; it lives on the linked RewardConfig →
 * PromoToken.couponCodes[0]. See `ChallengeCommunityGoalResponse` for the
 * shape emitted by the gated community-goal endpoint, which adds the
 * resolved `sharedUnlockCode` once `unlockedAt` is set.
 * 
 * @export
 * @interface ChallengeCommunityGoal
 */
export interface ChallengeCommunityGoal {
    /**
     * Aggregate count toward target. Updated via admin sync.
     * @type {number}
     * @memberof ChallengeCommunityGoal
     */
    current: number;
    /**
     * Threshold required to trigger community unlock.
     * @type {number}
     * @memberof ChallengeCommunityGoal
     */
    target: number;
    /**
     * Unix ms of the last successful current-count sync.
     * @type {number}
     * @memberof ChallengeCommunityGoal
     */
    lastSyncAt?: number;
    /**
     * CDN URL for the community reward art. Optional override of the linked RewardConfig's display image.
     * @type {string}
     * @memberof ChallengeCommunityGoal
     */
    rewardImageUrl?: string;
    /**
     * Display name for the community reward. Optional override of the linked RewardConfig's name.
     * @type {string}
     * @memberof ChallengeCommunityGoal
     */
    rewardName?: string;
    /**
     * Reference to the RewardConfig that backs the community reward.
     * @type {string}
     * @memberof ChallengeCommunityGoal
     */
    rewardConfigId?: string;
}

/**
 * Check if a given object implements the ChallengeCommunityGoal interface.
 */
export function instanceOfChallengeCommunityGoal(value: object): value is ChallengeCommunityGoal {
    if (!('current' in value) || value['current'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function ChallengeCommunityGoalFromJSON(json: any): ChallengeCommunityGoal {
    return ChallengeCommunityGoalFromJSONTyped(json, false);
}

export function ChallengeCommunityGoalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeCommunityGoal {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'],
        'target': json['target'],
        'lastSyncAt': json['lastSyncAt'] == null ? undefined : json['lastSyncAt'],
        'rewardImageUrl': json['rewardImageUrl'] == null ? undefined : json['rewardImageUrl'],
        'rewardName': json['rewardName'] == null ? undefined : json['rewardName'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
    };
}

export function ChallengeCommunityGoalToJSON(json: any): ChallengeCommunityGoal {
    return ChallengeCommunityGoalToJSONTyped(json, false);
}

export function ChallengeCommunityGoalToJSONTyped(value?: ChallengeCommunityGoal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': value['current'],
        'target': value['target'],
        'lastSyncAt': value['lastSyncAt'],
        'rewardImageUrl': value['rewardImageUrl'],
        'rewardName': value['rewardName'],
        'rewardConfigId': value['rewardConfigId'],
    };
}

